import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { InfoDataKeys } from 'src/app/interfaces/interface-key-captcha/info-data-keys.interface';

@Injectable({
  providedIn: 'root'
})
export class KeyRecaptchaServiceService {
  private pathJson: string = './assets/data/api-keys.json';

  constructor(private http: HttpClient) { }

  getKeyRecaptcha(): Observable<InfoDataKeys> {
    return this.http.get<{keys: InfoDataKeys}>(this.pathJson).pipe(
      map(response => {
        if (response && response.keys) {
          return response.keys;
        }
        // Retornar un objeto vacío si no hay keys
        return {} as InfoDataKeys;
      }),
      catchError(error => {
        console.error('Error al obtener claves de reCAPTCHA:', error);
        // Retornar un objeto vacío en caso de error
        return of({} as InfoDataKeys);
      })
    );
  }
}
